import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
    error: false,
};

const editEmpAlbumsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types. EDIT_EMP_ALBUMS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types. EDIT_EMP_ALBUMS_SUCCESS:
            return {
                ...state,
                loading: false,
                success:true,
                error: false,
            };
        case types. EDIT_EMP_ALBUMS_FAILURE:
            return {
                ...state,
                loading: false,
                success:false,
                error: true,
            };
        case types. EDIT_EMP_ALBUMS_RESET:
                return {
                    ...state,
                    success:false,
                };  
        default:
            return state;
    }
};
export default editEmpAlbumsReducer;
